import { BaseApiRouteService } from "mrb/core";

class LoadioArtistApiRouteService extends BaseApiRouteService {
    constructor() {
        super("loadio/artists");
    }

    find(filter) {
        return super.find(
            `${this.base}/{?searchQuery,page,rpp,sort,embed,fields,loadioContentProfileId,assigned,genreId}`,
            filter
        );
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?embed,fields}`, id, options);
    }

    updateActiveStatus(id, value) {
        return super.update(`${this.base}/{id}/active{?value}`, {
            id: id,
            value: value,
        });
    }

    // create(resource) {
    //     return super.create(this.base, resource);
    // }

    // update(resource) {
    //     return super.update(`${this.base}/{id}`, resource);
    // }

    // delete(resource) {
    //     return super.delete(`${this.base}/{id}`, resource);
    // }
}

export default LoadioArtistApiRouteService;
